import React from "react";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-blue-100 text-gray-800 px-6 py-10">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold mb-4 border-b pb-2">
          Privacy Policy
        </h1>
        <p className="text-sm mb-8">Last updated: July 25, 2025</p>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">1. Information We Collect</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Uploaded audio files (temporary, for transcription only)</li>
            <li>IP address (to prevent abuse and manage server load)</li>
            <li>User-Agent (for basic analytics and debugging)</li>
          </ul>
          <p className="mt-2">
            We do not collect names, emails, or any personal information unless you explicitly provide it.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">2. How We Use Your Data</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Convert audio to text</li>
            <li>Prevent spam or duplicate requests from the same IP</li>
            <li>Monitor system usage and performance</li>
          </ul>
          <p className="mt-2">Your audio and transcript are never shared or used for AI training.</p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">3. Data Retention</h2>
          <p>Uploaded files are deleted after processing (or within a few hours).</p>
          <p>Transcripts are not stored unless explicitly requested.</p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">4. Third-Party Services</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Redis (for IP request locking)</li>
            <li>Cloud hosting (e.g., Google Cloud Platform)</li>
          </ul>
          <p className="mt-2">These services cannot access your audio content.</p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">5. Cookies</h2>
          <p>We do not use cookies for tracking or analytics.</p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">6. Security</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>HTTPS encryption</li>
            <li>Secure infrastructure</li>
            <li>Minimal access to temporary files</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">7. Your Rights</h2>
          <p>You can request removal of data or stop using the service at any time.</p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">8. Changes to This Policy</h2>
          <p>We may update this policy. Changes will be posted here.</p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">9. Contact Us</h2>
          <p>
            <strong>Email:</strong> contact@pscribes.com <br />
            <strong>Website:</strong> <a href="https://www.pscribes.com" className="text-blue-600 underline">www.pscribes.com</a>
          </p>
        </section>
		For more details, please see our <a href="/terms" className="text-blue-600 underline">Terms of Service</a> or <a href="/contact" className="text-blue-600 underline">Contact Us</a>
      </div>
    </div>
  );
};

export default Privacy;
